export default __webpack_public_path__ + "static/media/DSC_7836.c767e366.jpg";